import BookingLineDetailModal from './booking-line-detail-modal';

export default BookingLineDetailModal;
